import './index.scss';

import { Component } from 'react';
import { BraxIcon, BraxLogo } from 'design-system';

import t from '../../utils/i18n';

export default class PlansFooter extends Component {

    render() {
        return (
            <div className="plans-footer">
                <BraxLogo type="logotype" variant="primary" />

                <div>
                    <div>
                        <p>{ t('Formas de pagamento') }</p>

                        <img src="/assets/images/payment-methods.png" alt={t('Bandeiras de cartão de crédito aceitas')} />
                    </div>

                    <div>
                        <BraxIcon icon="card-locked" />

                        <p className="hint">{ t('Todas as compras efetuadas neste site são 100% seguras, incluindo seus dados pessoais e dados do seu cartão.') }</p>
                    </div>
                </div>
            </div>
        );
    }

}
